import { css as i } from "@microsoft/fast-element";
import { normalize as s } from "../../common/normalize.js";
import { display as u } from "@matrix42/fast-foundation";
import { typography as r } from "../../styles/typography.js";
import { designTokens as e } from "../../design-tokens.js";
import { PropertiesStylesheetBehavior as o } from "../../common/behaviors/properties-stylesheet-behavior.js";
function a(t, l) {
  return i`
    .step-icon {
      /* Style */
      background-color: ${e.color[t][100]};
    }

    .label {
      /* Style */
      color: ${e.color.neutral[500]};

      /* Typography */
      ${r("h6", l)}
    }

    .subtitle {
      /* Style */
      color: ${e.color.neutral[500]};
    }
  `;
}
function n(t, l) {
  return i`
    .step-icon {
      /* Style */
      background-color: ${e.color[t][80]};
    }

    .label {
      /* Typography */
      ${r("h6", l)}

      /* Style */
      color: ${e.color.neutral[100]};
    }
  `;
}
function c(t) {
  return i`
    .control:hover .label {
      /* Style */
      color: ${e.color.neutral[200]};
    }

    .control:hover .subtitle {
      /* Style */
      color: ${e.color.neutral[200]};
    }

    .control:hover .step-icon {
      /* Style */
      background-color: ${e.color[t][90]};
    }
  `;
}
const b = i`
  ${s}
  ${u("flex")}
  .control {
    /* Layout */
    display: flex;
    cursor: pointer !important;
    box-sizing: border-box;
    min-height: ${e.spacing[12]};
    flex-direction: column;
  }

  .control:focus-visible {
    /* Style */
    outline: ${e.borderWidth.sm} solid ${e.color.black};
    border-radius: ${e.borderRadius.sm};
  }

  :host {
    /* Layout */
    text-align: center;
    align-items: center;

    /* Typography */
    ${r("p", "regular")}
  }

  .step-icon-container {
    /* Layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: ${e.spacing[1]} ${e.spacing[3]}
      ${e.spacing[1]} ${e.spacing[1]};
    min-height: ${e.spacing[12]};
  }

  .step-icon-container:focus-visible {
    /* Style */
    outline: ${e.borderWidth.sm} solid ${e.color.black};
    border-radius: ${e.borderRadius.md};
  }

  .step-icon {
    /* Layout */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    min-width: ${e.spacing[9]};
    min-height: ${e.spacing[9]};

    /* Style */
    border-radius: ${e.borderRadius.full};
    transition: background-color ${e.transition.fast},
      color ${e.transition.fast};
    color: ${e.color.white};
  }

  .step-icon-index {
    /* Typography */
    ${r("h5", "semibold")}
  }

  .icon {
    /* Style */
    color: ${e.color.white};
  }

  .label-container {
    /* Layout */
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-left: ${e.spacing[3]};
    gap: ${e.spacing[1]};
  }

  .label {
    ${r("h6", "semibold")}
  }

  .subtitle {
    /* Layout */
    margin-bottom: 0;

    /* Style */
    color: ${e.color.neutral[100]};

    /* Typography */
    ${r("label", "regular")}
  }
`.withBehaviors(
  new o(
    ["status", "active"],
    (t) => t.active && t.status === "default",
    a("primary", "semibold")
  ),
  new o(
    ["status", "active"],
    (t) => t.active && t.status === "complete",
    a("success", "semibold")
  ),
  new o(
    ["status", "active"],
    (t) => t.active && t.status === "incomplete",
    a("error", "semibold")
  ),
  new o(
    ["status", "active"],
    (t) => !t.active && t.status === "default",
    n("neutral", "regular")
  ),
  new o(
    ["status", "active"],
    (t) => !t.active && t.status === "complete",
    n("neutral", "semibold")
  ),
  new o(
    ["status", "active"],
    (t) => !t.active && t.status === "incomplete",
    n("error", "semibold")
  ),
  new o(
    ["status", "active"],
    (t) => !t.active && t.status === "complete",
    c("neutral")
  ),
  new o(
    ["status", "active"],
    (t) => !t.active && t.status === "incomplete",
    c("error")
  ),
  new o(
    ["status", "active"],
    (t) => !t.active && t.status === "default",
    c("neutral")
  )
);
export {
  b as stepIconStyles
};
